// src/store/services/proof-of-work.js
import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class ProofOfWork extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  
  static modelName = 'ProofOfWork'
  
  static instanceDefaults() {
    return {
      traineeCompetenciesId: null,
      fileUrl: '',
      externalLink: '',
      notes: '',
      status: 'pending'
    }
  }
}

const servicePath = 'proof-of-work'

const servicePlugin = makeServicePlugin({
  Model: ProofOfWork,
  service: feathersClient.service(servicePath),
  servicePath
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin